import { Component, Inject } from '@angular/core';
import { AssetDropdownService } from '../assets/assets-dropdown.service';
import { cdkOverlayRef } from '../custom-overlay/cdk-overlay-ref';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormArray, ValidatorFn, Validators } from '@angular/forms';
import { forkJoin, Subject } from 'rxjs';
import { LogSearchService } from 'src/app/log-search/services/log-search.service';
import { AdvanceFilterComponent } from 'src/app/alerts/template/advance-filter/advance-filter.component';
import { CdkOverlyayService } from '../custom-overlay/cdk-overlyay.service';
import { TimePanelComponent } from 'src/app/log-search/time-panel/time-panel.component';
import { OverlayService } from 'src/app/log-search/services/overlay.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { FILE_PREVIEW_DIALOG_DATA } from '../custom-overlay/cdk-overlay-injector';
import { LogsearchvarService } from 'src/app/log-search/services/logsearchvar.service';
import { KeyValue, PathLocationStrategy } from '@angular/common';
import { ToastService } from '../custom-overlay/toast/toast.service';


@Component({
  selector: 'app-search-suggestion-log-search',
  templateUrl: './search-suggestion-log-search.component.html',
  styleUrls: ['./search-suggestion-log-search.component.scss']
})
export class SearchSuggestionLogSearchComponent {
  //to hold the dropdowns metadata
  // assetsMetaData = this.assetsService.loadmetaData().common_top_bar;
  assetslabels = this.assetsService.loadlabels();
  platformdata = this.assetsService.loadplatformdata();
  $destroy: Subject<boolean> = new Subject();

  platformList = JSON.parse(JSON.stringify(this.platformdata))
  // relative_time_options:any=[]
  relative_times: any = []
  show_relative_times: any = []
  selectedPlatform: string = ''
  selectedfield: string = ''
  platformfields: any = []
  lexiconValue: any = []
  sourceErrorState: boolean = false
  sourceErrorMsg: string = ''
  selectedfieldCount: number = 0
  selectedPlatformValue: string = ''

  suggestionSpinnerState: boolean = true
  suggestionplatformSpinnerState: boolean = true
  suggestionsourceSpinnerState: boolean = true
  suggestionfieldSpinnerState: boolean = true
  suggestionvalueSpinnerState: boolean = true
  selectedTimeRange = 'Last 7 Days'
  selectedTimeStructure = {
    "disp": "Last 7 Days",
    "value": [
      "-",
      "day",
      6,
      0
    ]
  }
  

  suggestion_chips = []
  internalOverlayRef;
  timeRange = new FormControl('')




  assetsData: any;

  submitValid:boolean

  selectedHost: any = []
  fieldsList: any = []

  fieldsValue: any = []

  switchLabelText: string = 'Source'

  partitionLimitReached:boolean =false

  readyToAdd:boolean =false


  structure={}

  defaultStructure={}

  rootList=[]

  levelList

  selectedNode=''

  selected=[]

  chipsLimit=5

  hoverPath=[]

  form = new FormGroup({
    selectedAlias: new FormArray([])
  })

  chipsErrors={"identifierError":"Invalid alias","required":"*Alias can't be empty"}

  selectedPath={}
  mydata:any

  // mydata = [
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.LAN-DMZ.Deny",
  //     "partition_type": "LAN-DMZ",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": null,
  //     "partition_name": "Firewall.Paloalto.traffic.LAN-DMZ.Allow",
  //     "partition_type": "LAN-DMZ",
  //     "vendor_product": "Paloalto"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": null,
  //     "partition_name": "Firewall.Paloalto.traffic.LAN-DMZ.Deny",
  //     "partition_type": "LAN-DMZ",
  //     "vendor_product": "Paloalto"
  //   },
  //   {
  //     "sub_type": null,
  //     "technology": "Router",
  //     "event_class": "",
  //     "model_device": null,
  //     "partition_name": "Router.Cisco.All",
  //     "partition_type": "All",
  //     "vendor_product": "Cisco"
  //   },
  //   {
  //     "sub_type": null,
  //     "technology": "Switch",
  //     "event_class": "",
  //     "model_device": null,
  //     "partition_name": "Switch.Cisco.All",
  //     "partition_type": "All",
  //     "vendor_product": "Cisco"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.LAN-DMZ.Allow",
  //     "partition_type": "LAN-DMZ",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.DMZ-LAN.Allow",
  //     "partition_type": "DMZ-LAN",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.DMZ-LAN.Deny",
  //     "partition_type": "DMZ-LAN",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.Public-LAN.Allow",
  //     "partition_type": "Public-LAN",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.Public-LAN.Deny",
  //     "partition_type": "Public-LAN",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.Public-DMZ.Allow",
  //     "partition_type": "Public-DMZ",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.Public-DMZ.Deny",
  //     "partition_type": "Public-DMZ",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.LAN-Public.Allow",
  //     "partition_type": "LAN-Public",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.LAN-Public.Deny",
  //     "partition_type": "LAN-Public",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Allow",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.DMZ-Public.Allow",
  //     "partition_type": "DMZ-Public",
  //     "vendor_product": "Fortinet"
  //   },
  //   {
  //     "sub_type": "Deny",
  //     "technology": "Firewall",
  //     "event_class": "traffic",
  //     "model_device": "Fortigate",
  //     "partition_name": "Firewall.Fortinet.Fortigate.traffic.DMZ-Public.Deny",
  //     "partition_type": "DMZ-Public",
  //     "vendor_product": "Fortinet"
  //   }
  // ]



  // clickedNode=JSON.parse(JSON.stringify(this.mydata))

  clickedNode=[]

  keepTrack=[]

  keepTrackJr={
    "event_class":"",
    "model_device":"",
    "sub_type":"",
    "technology":"",
    "vendor_product":"",
    "partition_type":""
  }

  keepTrackDefault={
    "event_class":"",
    "model_device":"",
    "sub_type":"",
    "technology":"",
    "vendor_product":"",
    "partition_type":""
  }

 

  // sampleData={
  //   "roots": [
  //     "firewall",
  //     "router",
  //     "switch"
  //   ],
  //   "nodes": {
  //     "firewall": {
  //       "id": "firewall",
  //       "label": "Firewall",
  //       "level": "Technology",
  //       "parentId": "",
  //       "parentLevel": "",
  //       "childrenIds": [
  //         "firewall/fortinet",
  //         "firewall/paloalto"
  //       ]
  //     },
  //     "router": {
  //       "id": "router",
  //       "label": "Router",
  //       "level": "Technology",
  //       "parentId": "",
  //       "parentLevel": "",
  //       "childrenIds": [
  //         "router/cisco"
  //       ]
  //     },
  //     "switch": {
  //       "id": "switch",
  //       "label": "Switch",
  //       "level": "Technology",
  //       "parentId": "",
  //       "parentLevel": "",
  //       "childrenIds": [
  //         "switch/cisco"
  //       ]
  //     },
  //     "firewall/fortinet": {
  //       "id": "firewall/fortinet",
  //       "label": "Fortinet",
  //       "level": "Vendor/Product",
  //       "parentId": "firewall",
  //       "parentLevel": "Technology",
  //       "childrenIds": [
  //         "firewall/fortinet/fortigate"
  //       ]
  //     },
  //     "firewall/paloalto": {
  //       "id": "firewall/paloalto",
  //       "label": "Paloalto",
  //       "level": "Vendor/Product",
  //       "parentId": "firewall",
  //       "parentLevel": "Technology",
  //       "childrenIds": [
  //         "firewall/paloalto/traffic"
  //       ]
  //     },
  //     "router/cisco": {
  //       "id": "router/cisco",
  //       "label": "Cisco",
  //       "level": "Vendor/Product",
  //       "parentId": "router",
  //       "parentLevel": "Technology",
  //       "childrenIds": [
  //         "router/cisco/all"
  //       ]
  //     },
  //     "switch/cisco": {
  //       "id": "switch/cisco",
  //       "label": "Cisco",
  //       "level": "Vendor/Product",
  //       "parentId": "switch",
  //       "parentLevel": "Technology",
  //       "childrenIds": [
  //         "switch/cisco/all"
  //       ]
  //     },
  //     "firewall/fortinet/fortigate": {
  //       "id": "firewall/fortinet/fortigate",
  //       "label": "Fortigate",
  //       "level": "Model/Device Name",
  //       "parentId": "firewall/fortinet",
  //       "parentLevel": "Vendor/Product",
  //       "childrenIds": [
  //         "firewall/fortinet/fortigate/traffic"
  //       ]
  //     },
  //     "firewall/fortinet/fortigate/traffic": {
  //       "id": "firewall/fortinet/fortigate/traffic",
  //       "label": "traffic",
  //       "level": "Event Class",
  //       "parentId": "firewall/fortinet/fortigate",
  //       "parentLevel": "Model/Device Name",
  //       "childrenIds": [
  //         "firewall/fortinet/fortigate/traffic/lan-dmz"
  //       ]
  //     },
  //     "firewall/paloalto/traffic": {
  //       "id": "firewall/paloalto/traffic",
  //       "label": "traffic",
  //       "level": "Event Class",
  //       "parentId": "firewall/paloalto",
  //       "parentLevel": "Vendor/Product",
  //       "childrenIds": [
  //         "firewall/paloalto/traffic/lan-dmz"
  //       ]
  //     },
  //     "router/cisco/all": {
  //       "id": "router/cisco/all",
  //       "label": "All",
  //       "level": "Type",
  //       "parentId": "router/cisco",
  //       "parentLevel": "Vendor/Product",
  //       "childrenIds": []
  //     },
  //     "switch/cisco/all": {
  //       "id": "switch/cisco/all",
  //       "label": "All",
  //       "level": "Type",
  //       "parentId": "switch/cisco",
  //       "parentLevel": "Vendor/Product",
  //       "childrenIds": []
  //     },
  //     "firewall/paloalto/traffic/lan-dmz": {
  //       "id": "firewall/paloalto/traffic/lan-dmz",
  //       "label": "LAN-DMZ",
  //       "level": "Type",
  //       "parentId": "firewall/paloalto/traffic",
  //       "parentLevel": "Event Class",
  //       "childrenIds": [
  //         "firewall/paloalto/traffic/lan-dmz/allow",
  //         "firewall/paloalto/traffic/lan-dmz/deny"
  //       ]
  //     },
  //     "firewall/fortinet/fortigate/traffic/lan-dmz": {
  //       "id": "firewall/fortinet/fortigate/traffic/lan-dmz",
  //       "label": "LAN-DMZ",
  //       "level": "Type",
  //       "parentId": "firewall/fortinet/fortigate/traffic",
  //       "parentLevel": "Event Class",
  //       "childrenIds": [
  //         "firewall/fortinet/fortigate/traffic/lan-dmz/allow",
  //         "firewall/fortinet/fortigate/traffic/lan-dmz/deny"
  //       ]
  //     },
  //     "firewall/fortinet/fortigate/traffic/lan-dmz/deny": {
  //       "id": "firewall/fortinet/fortigate/traffic/lan-dmz/deny",
  //       "label": "Deny",
  //       "level": "Subtype",
  //       "parentId": "firewall/fortinet/fortigate/traffic/lan-dmz",
  //       "parentLevel": "Type",
  //       "childrenIds": []
  //     },
  //     "firewall/fortinet/fortigate/traffic/lan-dmz/allow": {
  //       "id": "firewall/fortinet/fortigate/traffic/lan-dmz/allow",
  //       "label": "Allow",
  //       "level": "Subtype",
  //       "parentId": "firewall/fortinet/fortigate/traffic/lan-dmz",
  //       "parentLevel": "Type",
  //       "childrenIds": []
  //     },
  //     "firewall/paloalto/traffic/lan-dmz/allow": {
  //       "id": "firewall/paloalto/traffic/lan-dmz/allow",
  //       "label": "Allow",
  //       "level": "Subtype",
  //       "parentId": "firewall/paloalto/traffic/lan-dmz",
  //       "parentLevel": "Type",
  //       "childrenIds": []
  //     },
  //     "firewall/paloalto/traffic/lan-dmz/deny": {
  //       "id": "firewall/paloalto/traffic/lan-dmz/deny",
  //       "label": "Deny",
  //       "level": "Subtype",
  //       "parentId": "firewall/paloalto/traffic/lan-dmz",
  //       "parentLevel": "Type",
  //       "childrenIds": []
  //     }
  //   }
  // }
  sampleData

  assetSearch = new FormControl()




  constructor(

    public assetsService: AssetDropdownService,
    private overLayRef: cdkOverlayRef,
    private cdkoverlayDialog: CdkOverlyayService,
    private dropdown: OverlayService,
    private sharedService: SharedService,
    private logSearchService: LogSearchService,
    public logvarservice: LogsearchvarService,
    private toasterServie : ToastService,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public data: any

  ) { }

  // timerange:FormControl = new FormControl([ "-1","hour",24])
  // toggle
  platformSearch
  sourceSearch
  fieldsSearch
  valueSearch
  sourceSelectAll

  newSample:any

  newData:any

  // newSample={
  //   "roots": [
  //     "technology_firewall",
  //     "technology_router",
  //     "technology_switch",
  //     null
  //   ],
  //   "nodes": {
  //     "technology_firewall": {
  //       "id": "technology_firewall",
  //       "label": "Firewall",
  //       "level": "Technology",
  //       "parentIds": [],
  //       "childrenIds": [
  //         "vendor_product_fortinet",
  //         "vendor_product_paloalto"
  //       ]
  //     },
  //     "technology_router": {
  //       "id": "technology_router",
  //       "label": "Router",
  //       "level": "Technology",
  //       "parentIds": [],
  //       "childrenIds": [
  //         "vendor_product_cisco"
  //       ]
  //     },
  //     "technology_switch": {
  //       "id": "technology_switch",
  //       "label": "Switch",
  //       "level": "Technology",
  //       "parentIds": [],
  //       "childrenIds": [
  //         "vendor_product_cisco"
  //       ]
  //     },
  //     "vendor_product_cisco": {
  //       "id": "vendor_product_cisco",
  //       "label": "Cisco",
  //       "level": "Vendor/Product",
  //       "parentIds": [
  //         "technology_router",
  //         "technology_switch"
  //       ],
  //       "childrenIds": [
  //         "type_all"
  //       ]
  //     },
  //     "vendor_product_fortinet": {
  //       "id": "vendor_product_fortinet",
  //       "label": "Fortinet",
  //       "level": "Vendor/Product",
  //       "parentIds": [
  //         "technology_firewall"
  //       ],
  //       "childrenIds": [
  //         "model_device_name_fortigate"
  //       ]
  //     },
  //     "vendor_product_paloalto": {
  //       "id": "vendor_product_paloalto",
  //       "label": "Paloalto",
  //       "level": "Vendor/Product",
  //       "parentIds": [
  //         "technology_firewall"
  //       ],
  //       "childrenIds": [
  //         "event_class_traffic"
  //       ]
  //     },
  //     "model_device_name_fortigate": {
  //       "id": "model_device_name_fortigate",
  //       "label": "Fortigate",
  //       "level": "Model/Device Name",
  //       "parentIds": [
  //         "vendor_product_fortinet"
  //       ],
  //       "childrenIds": [
  //         "event_class_traffic"
  //       ]
  //     },
  //     "event_class_traffic": {
  //       "id": "event_class_traffic",
  //       "label": "traffic",
  //       "level": "Event Class",
  //       "parentIds": [
  //         "model_device_name_fortigate",
  //         "vendor_product_paloalto"
  //       ],
  //       "childrenIds": [
  //         "type_lan-dmz"
  //       ]
  //     },
  //     "type_all": {
  //       "id": "type_all",
  //       "label": "All",
  //       "level": "Type",
  //       "parentIds": [
  //         "vendor_product_cisco"
  //       ],
  //       "childrenIds": [
  //         null
  //       ]
  //     },
  //     "type_lan-dmz": {
  //       "id": "type_lan-dmz",
  //       "label": "LAN-DMZ",
  //       "level": "Type",
  //       "parentIds": [
  //         "event_class_traffic"
  //       ],
  //       "childrenIds": [
  //         "subtype_allow",
  //         "subtype_deny"
  //       ]
  //     },
  //     "subtype_allow": {
  //       "id": "subtype_allow",
  //       "label": "Allow",
  //       "level": "Subtype",
  //       "parentIds": [
  //         "type_lan-dmz"
  //       ],
  //       "childrenIds": []
  //     },
  //     "subtype_deny": {
  //       "id": "subtype_deny",
  //       "label": "Deny",
  //       "level": "Subtype",
  //       "parentIds": [
  //         "type_lan-dmz"
  //       ],
  //       "childrenIds": []
  //     }
  //   }
  // }

  newStructure={}
  newDefaultStructure={}

  header=[]
  headerObj:any
  // headerObj=[
  //   {
  //     "disp": "Technology",
  //     "value": "technology"
  //   },
  //   {
  //     "disp": "Vendor/Product",
  //     "value": "vendor_product"
  //   },
  //   {
  //     "disp": "Model/Device",
  //     "value": "model_device"
  //   },
  //   {
  //     "disp": "Event class",
  //     "value": "event_class"
  //   },
  //   {
  //     "disp": "Type",
  //     "value": "partition_type"
  //   },
  //   {
  //     "disp": "Sub type",
  //     "value": "sub_type"
  //   }
  // ]

  async ngOnInit() {

 

    // console.log("data =---->",this.data)
 
    // console.log(this.getcolumn('event_class'))

    // this.getHeader()

    // console.log(this.queryTable(this.mydata,{model_device: "Fortigate"}))

    // console.log(this.header)

    // this.header.forEach(val=>{
    //   console.log(this.getcolumn(val))
    // })

// console.log(this.data)

    // await this.getPartition().then(data=>{
      // console.log(data)
    //   this.sampleData=data
    // })

    let partition =JSON.parse(JSON.stringify(this.sharedService.partitions))

    if(this.data.mode =="rule"){

//console.log(this.sharedService.partitions)

      partition["rows"]=[]
      this.sharedService.partitions.rows.forEach(part=>{
        if(part.platform_id != 0){
          partition["rows"].push(part)
        }
      })
     

    }else{
      // partition= JSON.parse(JSON.stringify(this.sharedService.partitions))
    }
    // this.newData=JSON.parse(JSON.stringify(this.sharedService.partitions))
    // this.sampleData=JSON.parse(JSON.stringify(this.sharedService.partitions))
    // this.newSample=JSON.parse(JSON.stringify(this.sharedService.partitions))

    this.newData=JSON.parse(JSON.stringify(partition))
    this.sampleData=JSON.parse(JSON.stringify(partition))
    this.newSample=JSON.parse(JSON.stringify(partition))

    this.headerObj=this.newData.headers
    this.mydata=this.newData.rows

    this.clickedNode=JSON.parse(JSON.stringify(this.mydata))

//console.log("->",this.newData)

    // this.levelList = this.getLevelList()
    // this.newDefault()
    // this.getDefault()

    if(this.data.partitions.length){
      this.preProcess()
    }

    // console.log(document.getElementById(this.data[0].platform))
    
    // console.log(this.platformList)
    // this.platformList.forEach(list=>{
    //   if(this.data[0].platform === list.value){
    //     list["selected"]=true
    //   }else{
    //     list["selected"]=false
    //   }
    // })
   
   
    // this.toggle = new FormControl(false);
    // this.sourceSelectAll = new FormControl(false)
    // this.platformSearch = new FormControl('')
    // this.sourceSearch = new FormControl('')
    // this.fieldsSearch = new FormControl('')
    // this.valueSearch = new FormControl('')

    // this.buildDefaultRequest()

    // console.log("this.logSearchService.relative_times=========",this.logSearchService.relative_times)
    // this.timerange.patchValue()
    // this.relative_time_options = this.sharedService.metaData.logsearch.common_top_bar.search_bar.time_panel.relative_time_options
    // console.log("this.relative_time_options=[======",this.relative_time_options)
    // this.relative_times = this.logSearchService.relative_times
    // this.fetchSelectedTimeRange(this.relative_times, this.selectedTimeRange, this.selectedTimeStructure)
    // this.show_relative_times = this.relative_times.slice(0,3)
    //  this.relative_times=[{
    //   "disp": "Last 24 Hours",
    //   "value": [
    //     "-",
    //     "hour",
    //     24,
    //     0
    //   ]
    // },{
    //   "disp": "Last 7 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     6,
    //     0
    //   ]
    // },
    // {
    //   "disp": "Last 10 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     9,
    //     0
    //   ]

    // },
    // {
    //   "disp": "Last 30 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     29,
    //     0
    //   ]

    // }
    // ]

    // this.platformSearch.valueChanges.subscribe((platformSearchVal: string) => {
    //   if (platformSearchVal != '') {
    //     this.platformList = [...this.platformdata.filter((item: any) => {
    //       return item['disp'].toLowerCase().includes(platformSearchVal.toLowerCase())
    //     })]
    //   }
    //   else {
    //     this.platformList = JSON.parse(JSON.stringify(this.platformdata))
    //     this.platformList.forEach(list=>{
    //       list["selected"]=false
    //     })
    //   }
    // })


    // this.sourceSearch.valueChanges.subscribe((sourceSearchVal: string) => {
    //   if (sourceSearchVal != '') {
    //     this.selectedHost = [...this.assetsData[0].partitions.filter((item: any) => {
    //       return item['disp'].toLowerCase().includes(sourceSearchVal.toLowerCase())
    //     })]
    //     if (this.selectedHost.length == 0) {
    //       this.sourceSelectAll.setValue(false, { emitEvent: false })
    //     }

    //   }
    //   else {
    //     if(this.assetsData[0].partitions){
    //       this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0]?.partitions))
    //     }else{
    //       this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0]?.hosts))
    //     }

    //   }
    //   this.toggleActionSourceSelectall(false, sourceSearchVal, 'search')
    // })


    // this.fieldsSearch.valueChanges.subscribe((fieldsSearchVal: string) => {
    //   if (fieldsSearchVal != '') {
    //     this.fieldsList = [...this.platformfields.filter((item: any) => {
    //       return item['disp'].toLowerCase().includes(fieldsSearchVal.toLowerCase())
    //     })]
    //   }
    //   else {
    //     this.fieldsList = JSON.parse(JSON.stringify(this.platformfields))
    //   }
    // })


    // this.valueSearch.valueChanges.subscribe((valueSearchVal: string) => {
    //   if (valueSearchVal != '') {
    //     this.fieldsValue = [...this.lexiconValue.filter((item: string) => {
    //       return item.toLowerCase().includes(valueSearchVal.toLowerCase())
    //     })]
    //   }
    //   else {
    //     this.fieldsValue = JSON.parse(JSON.stringify(this.lexiconValue))
    //   }
    // })

    // this.sourceSelectAll.valueChanges.subscribe((selected: boolean) => {
    //   // console.log("this.sourceSelectAll.valueChanges=======",selected)
    //   this.toggleActionSourceSelectall(selected, '', 'valueChange')
    // })



  //   this.dropdown.time$.pipe(takeUntil(this.$destroy))
  //     .subscribe((data: any) => {

  //       // let selectedTimeObj = [data]

  //       // this.relative_times.forEach((item:any)=>{
  //       //   if(item.disp != data.disp){
  //       //   selectedTimeObj.push(item)

  //       //   }
  //       // })
  //       // this.show_relative_times = selectedTimeObj.slice(0,3)
  //       this.fetchSelectedTimeRange(this.relative_times, data.disp, data)
  //       this.selectedTimeRange = data.disp
  //       this.selectedTimeStructure = data
  //     })
  }

  getHeader(){
   
    Object.keys(this.mydata[0]).forEach(key=>{
      this.header.push(key)
    })
  }

  

  getPartition(){
    return(
    this.assetsService.getPartitionsList({'user_name':this.logSearchService.getusername()})
    ).toPromise()
  }

  rootHover(root,level){
    // console.log(this.sampleData.nodes[root])
    let strList = root.split('/')
    let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))
    this.hoverPath=pathList
    // if(level != this.sampleData.nodes[root].level){
    // this.levelList.forEach(key=>{
      // if(key !=this.sampleData.nodes[root].level){

        // console.log(root+'_'+key)
        // let parent=this.sampleData.nodes[root].parentId

        // while(parent.length){
        //   // console.log(parent)
        //   // setTimeout(() => {
        //     document.getElementById(parent+'_'+this.sampleData.nodes[parent].level)?.scrollIntoView({
        //     behavior: 'smooth',
        //     block: 'start',
        //     inline: 'nearest'
        //   });
        //   parent = this.sampleData.nodes[parent].parentId
        //   // }, 500);

        // }


      
      // }
    // })
    // }

  }

  checkHover(root){
    if(this.selectedNode === root){
      return false
    }else{
      if(this.hoverPath.includes(root)){
        return true
      }else{
        return false
      }
    }

  }

  ngAfterViewInit(){

    this.selectedAlias.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(data=>{
      // console.log(this.selectedAlias)
    })

    this.assetSearch.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(val=>{
      // Object.keys(this.selectedPath).forEach(key=>{
      //   this.selectedPath[key]=''
      //   this.readyToAdd=false
      // })
      // this.filterList(val)
      this.searchNodes(val)
      // if(val.length){
      //   // this.searchNodes(val)
      // }else{
      //   this.newStructure=JSON.parse(JSON.stringify(this.newDefaultStructure))
      //   // this.clickedNode =JSON.parse(JSON.stringify(this.mydata))
      // }
    })
    // console.log(document.getElementById(this.data[0].platform))
    if(this.data.partitions.length){
      setTimeout(() => {
        document.getElementById(this.data.partitions[0].platform)?.scrollIntoView({
        behavior: 'smooth'
      });
      }, 500);
    }
   
  }


  fetchSelectedTimeRange(relativetimes: any, seletedTime: string, timestruct: any) {
    this.show_relative_times.length = 0
    if (seletedTime.startsWith("Between") || seletedTime.startsWith("Since") || seletedTime.startsWith("Before")) {
      this.show_relative_times.push(timestruct)
    } else {
      relativetimes.forEach((item: any) => {
        if (item.disp == seletedTime) {
          this.show_relative_times.push(item)
        }
      })
    }

    relativetimes.forEach((item: any) => {
      if (this.show_relative_times.length < 3 && item.disp != seletedTime && (item.disp == "Last 7 Days" || item.disp == "Last 10 Days" || item.disp == "Last 30 Days")) {
        this.show_relative_times.push(item)
      }
    })

  }

  formCancel() {
    // if (!this.assetsService.assetsSpinnerState) {
    this.overLayRef.close()
    // }
  }

  formSubmit() {
    let hostlist = [];
    this.selectedHost.forEach((item: any) => {
      if (item["isSelected"]) {
        hostlist.push(item.value)
      }
    })
    // console.log('formSubmit hostlist',hostlist,this.selectedHost);

    if (hostlist.length > 0) {

      this.logSearchService.searchSeggestionFilters['hosts'] = hostlist
      this.logSearchService.searchSeggestionFilters['platform'] = this.selectedPlatformValue
      this.logSearchService.searchSeggestionFilters['time_range'] = this.selectedTimeStructure
      this.logSearchService.searchSeggestionFilters['time_range_disp'] = this.selectedTimeRange
      this.logSearchService.searchSeggestionFilters['selectedHost'] = this.selectedHost

      // this.formCancel()


      let responseobj = {
        "platform": this.selectedPlatformValue,
        "platformfields": this.platformfields,
        "uniqueHostsList": hostlist,
        "selectedTimeStructure": this.selectedTimeStructure,
        "value": this.selectedHost,
        "time_range_disp": this.selectedTimeRange
      }
      this.assetsService._savedAssets.next(responseobj)
      this.overLayRef._cube.next({ ...responseobj, ...{ "platformfields": this.platformfields } })
      this.overLayRef.close()
    }
    else {
      this.sourceErrorState = true
      this.sourceErrorMsg = "*Source name is required"
    }
    // console.log("sumbit click====================formSubmit")

  }

  fetchPlatformFields(platform: string) {
    return this.assetsService.getSuggestionPlatformFields({ 'platform': platform }).toPromise()
  }

  fetchFieldsValue(platform: string, field_name: string, limit: number) {
    return this.assetsService.getSuggestionFieldValue({ 'platform': platform, 'field_name': field_name, 'limit': limit }).toPromise()
  }

  fetchHostTagsdata(platform) {
    return forkJoin([
      // this.assetsService.getHostsList({ 'platform': platform }),
      this.assetsService.getPartitionsList({ 'platform': platform ,'user_name':this.logSearchService.getusername()}),
      this.assetsService.getHostsCategories({ 'platform': platform })
    ]).toPromise()
  }

//   scrollToId() {
//   document.getElementById('section1')?.scrollIntoView({
//     behavior: 'smooth'
//   });
// }

resetChips(){
  this.selected=[]
  // console.log(this.selectedAlias.length)
  for(let i = this.selectedAlias.length; i >= 0;i--){
    // console.log({i})
    this.selectedAlias.removeAt(i,{emitEvent:false})
  }
}

  ClickedPlatform(platform: any) {

    let index = this.platformList.findIndex(val=>val.value === platform.value)

    // this.platformList[index].selected= !this.platformList[index].selected

    this.suggestion_chips = []
    this.suggestionsourceSpinnerState = true
    this.suggestionfieldSpinnerState = true
    this.suggestionvalueSpinnerState = true

    this.sourceSearch.reset('')
    this.fieldsSearch.reset('')
    this.valueSearch.reset('')

    this.sourceSelectAll.setValue(false, { emitEvent: false })
    this.selectedPlatform = platform.disp
    this.selectedPlatformValue = platform.value
    // this.fetchPlatformFields(platform.value)
    //   .then((platformfields: any) => {
    //     if (platformfields.platform_fields.length) {
    //       this.platformfields = platformfields.platform_fields;
    //       this.fieldsList = this.platformfields
    //       // console.log("fetchPlatformFields========platformfields===========",platformfields)
    //       this.selectedfield = this.fieldsList[0].disp
    //       this.selectedfield = this.fieldsList[0].disp == 'hash_id' ? this.fieldsList[1].disp : this.fieldsList[0].disp
    //       this.selectedfieldCount = this.fieldsList[0].disp == 'hash_id' ? this.fieldsList[1].count : this.fieldsList[0].count
    //       this.fetchLexiconValue(this.selectedPlatformValue, this.selectedfield, this.selectedfieldCount)
    //         .then((fieldsres: any) => {
    //           this.lexiconValue = fieldsres?.field_value
    //           this.fieldsValue = this.lexiconValue

    //           this.buildSuggestionChipsStru()
              this.fetchHostTagsdata(platform.value)
                .then(assets => {

//console.log("-->",assets)

                  this.assetsData = assets
                  // for (let i = 0; i < this.assetsData[0]?.hosts?.length; i++) {
                  //   this.assetsData[0].partitions[i]["isSelected"] = (i == 0) ? true : false
                  //   this.assetsData[0].partitions[i]["index"] = i
                  // }
                  // this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].partitions))

                  // console.log(this.platformList)

                  let existsIndex=this.platformList.findIndex(list => list.value == this.selectedPlatformValue)
                  // console.log({existsIndex})

                  let exists

                  if(existsIndex != -1 && existsIndex != null){
                    if(this.platformList[existsIndex].selected){
                      exists = true
                    }else{
                      exists = false
                    }
                  }else{
                    exists = false
                  }

                  
                  // exists = this.platformList.some(list => list.selected);
                  // console.log({exists})
                  for (let i = 0; i < this.assetsData[0]?.partitions?.length; i++) {
                    // this.assetsData[0].partitions[i]["isSelected"] = (i == 0) ? true : false
                    if(!exists){
                      this.assetsData[0].partitions[i]["isSelected"] = false
                    }else{
                      this.assetsData[0].partitions[i]["isSelected"] = (i == 0) ? true : false
                    }
                    this.assetsData[0].partitions[i]["index"] = i
                  }
                  this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].partitions))
                  this.suggestionsourceSpinnerState = false
                  this.suggestionfieldSpinnerState = false
                  this.suggestionvalueSpinnerState = false

                })
                .catch((err) => {
                  //console.log("fetchHostTagsdata=======",err)
                })
      //       })
      //       .catch((err) => {
      //         //console.log("fetchLexiconValue=======",err)
      //       })
      //   } else {
      //     this.suggestionsourceSpinnerState = false
      //     this.suggestionfieldSpinnerState = false
      //     this.suggestionvalueSpinnerState = false
      //     this.selectedHost = []
      //     this.fieldsList = []
      //     this.fieldsValue = []
      //     this.platformfields = []
      //     this.lexiconValue = []
      //     this.assetsData[0].partitions = []

      //   }

        this.partitionLimitReached=false


      //   // this.loadnewplatform(platform);
      // }).catch((err) => {
      //   //console.log(err)
      // })

  }

  openOverlay(origin: any, component: any, componentInputs: any, dimensions: any) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    },
      origin, component)
    return this.overLayRef;
  }

  // openAdvancedFilter(origin: any, mode: number) {
  //   // console.log("openAdvancedFilter======", !this.isAction, this.alertvarService.advanced_filter_values, this.alertvarService.alertsheetmeta.filterOptions.advanceFilter)

  //   // if (!this.isAction) {
  //   const ref: cdkOverlayRef = this.openOverlay(origin, AdvanceFilterComponent,
  //     [
  //       { ...this.relative_time_options },
  //       { ...this.alertsheetmeta.filterOptions.advanceFilter }, mode]
  //     , mode ? ["45vh", "25vw"] : ["45vh", "55vw"]);
  //   // , ["45vh", "25vw"]);
  //   ref.$selectedValue.subscribe(response => {
  //     this.advanced_filter_values = response;
  //     this.advancedFilterChange.next(null);
  //   })
  //   // }
  // }

  buildSuggestionChipsStru() {
    this.suggestion_chips = []
    let limit = 0
    for (let val in this.fieldsValue) {
      if (!(this.fieldsValue[val] == '--NA--' || this.fieldsValue[val] == 'nil' || this.fieldsValue[val] == 'hash_id')) {
        this.suggestion_chips.push(this.fieldsValue[val])
        limit += 1
        if (limit > 2) {
          break
        }
      }
    }
    // console.log("buildSuggestionChipsStru",this.fieldsValue)
  }

  SelectedFields(fields: any, event: any) {
    this.suggestion_chips = []
    event.stopPropagation()
    this.selectedfield = fields.disp
//console.log('fields==',fields);

    if (fields.count > 0) {
      this.suggestionvalueSpinnerState = true
      this.fetchLexiconValue(this.selectedPlatformValue, fields.value, fields.count)
        .then((fieldsres: any) => {
          // console.log("SelectedFields",fieldsres)
          this.lexiconValue = fieldsres?.field_value
          this.fieldsValue = this.lexiconValue
          this.buildSuggestionChipsStru()
          this.suggestionvalueSpinnerState = false
        })
        .catch((err) => {
          //console.log("fetchLexiconValue===",err)
        })
    }


  }

  fetchLexiconValue(platform: string, field: string, limit: number) {
    limit = limit > 2000 ? 200 : limit
    return this.fetchFieldsValue(platform, field, limit)
  }

  buildDefaultRequest() {
    // console.log('this.logSearchService.searchSeggestionFilters',this.logSearchService.searchSeggestionFilters);

    // this.platformdata
    this.suggestion_chips = []

    // this.selectedPlatform = this.sharedService.platformMap[this.sharedService.metaData.commonData.platformOptions.default]
    // this.selectedPlatformValue = this.sharedService.metaData.commonData.platformOptions.default


    this.selectedPlatform = this.sharedService.platformMap[this.data.partitions[0]['platform']]
    this.selectedPlatformValue = this.data.partitions[0]['platform']
    this.selectedTimeStructure = this.data.partitions[1]
    this.selectedTimeRange = this.data.partitions[1]['disp']
    // this.selectedTimeRange = this.logSearchService.searchSeggestionFilters['time_range_disp']
    this.selectedHost = JSON.parse(JSON.stringify(this.data.partitions[0]['value']))
    this.logSearchService.suggestion_selected_platform = this.selectedPlatform
    // this.fetchPlatformFields(this.sharedService.metaData.commonData.platformOptions.default)
    this.fetchPlatformFields(this.data.partitions[0]['platform'])
      .then((platformfields: any) => {
        // console.log("buildDefaultRequest======",platformfields)
        this.platformfields = platformfields.platform_fields;
        this.fieldsList = this.platformfields
        this.selectedfield = this.fieldsList[0].disp
        this.fetchLexiconValue(this.selectedPlatformValue, this.fieldsList[0].value, this.fieldsList[0].count)
          .then((fieldsres: any) => {
            this.lexiconValue = fieldsres?.field_value
            this.fieldsValue = this.lexiconValue

            this.buildSuggestionChipsStru()
            // console.log('this.selectedHost ##',this.selectedHost);

            if (this.selectedHost.length == 0) {
              // this.fetchHostTagsdata(this.sharedService.metaData.commonData.platformOptions.default)
              this.fetchHostTagsdata(this.data.partitions[0]['platform'])

                .then(assets => {

                  this.assetsData = assets
                  for (let i = 0; i < this.assetsData[0]?.hosts?.length; i++) {

                    this.assetsData[0].partitions[i]["isSelected"] = (i == 0) ? true : false
                    this.assetsData[0].partitions[i]["index"] = i
                  }
                  this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].partitions))

                  // console.log("this.assetsData========",this.assetsData)
                  // this.suggestionplatformSpinnerState = false
                  // this.suggestionsourceSpinnerState = false
                  // this.suggestionfieldSpinnerState = false
                  // this.suggestionvalueSpinnerState = false
                })

                .catch((err) => {
                  //console.log(err)
                })
            } else {
              // this.assetsData = [{ "hosts": this.selectedHost, "no_of_hosts": this.selectedHost.length }]
              this.assetsData = [{ "partitions": this.selectedHost, "no_of_partitions": this.selectedHost.length }]
            }
            // console.log('this.selectedHost', this.selectedHost);
            this.suggestionplatformSpinnerState = false
            this.suggestionsourceSpinnerState = false
            this.suggestionfieldSpinnerState = false
            this.suggestionvalueSpinnerState = false

          })




      })
      .catch((err) => {
        //console.log(err)
      })
  }

  selectedSource(index: number, hostinfo: any, event: any) {
    this.sourceErrorMsg = ''
    this.sourceErrorState = false
    event.stopPropagation()

    // if(!this.partitionLimitReached){
      this.selectedHost[index]["isSelected"] = !this.selectedHost[index]["isSelected"]
      // console.log("hostinfo.index======",this.assetsData)
      // console.log("selectedHost======",this.selectedHost)
//console.log(this.assetsData[0],"/n",hostinfo.index)
      this.assetsData[0].partitions[hostinfo.index]["isSelected"] = this.selectedHost[index]["isSelected"]
    // }

    let valid = false

    for (let i = 0; i < this.selectedHost.length; i++) {
      if (this.selectedHost[i]["isSelected"]) {
        let index = this.platformList.findIndex(val => val.value === this.selectedPlatformValue)
        this.platformList[index].selected=true
        valid=true
        break
      }
    }
    if(!valid){
      let index = this.platformList.findIndex(val => val.value === this.selectedPlatformValue)
      this.platformList[index].selected=false
    }

    let selecteAllStatus = false
    // console.log(this.selectedHost)
    let selectedCount:number = 0 
    for (let i = 0; i < this.selectedHost.length; i++) {
      if (!this.selectedHost[i]["isSelected"]) {
        selecteAllStatus = true
        break
      }
    }

    for (let i = 0; i < this.selectedHost.length; i++) {
      if (this.selectedHost[i]["isSelected"]) {
        selectedCount+=1
      }
    }
    // console.log(this.selectedHost)
    // console.log({selectedCount})
    if(selectedCount === this.logvarservice.partitionLimit){
      this.partitionLimitReached = true
    }else{
      this.partitionLimitReached = false
    }
    // console.log("selectedSource----selecteAllStatus======",selecteAllStatus)
    if (selecteAllStatus) {
      this.sourceSelectAll.setValue(false, { emitEvent: false })
    }
    else {
      this.sourceSelectAll.setValue(true, { emitEvent: false })
    }
    // console.log("Partition Limit Reached ->",this.partitionLimitReached)
    
  }



  toggleActionSourceSelectall(status: boolean, searchval: string, mode: string) {
    // console.log("toggleActionSourceSelectall===========",status,searchval,mode)
    if (mode == 'valueChange') {
      for (let i = 0; i < this.selectedHost.length; i++) {

        // if(i < this.logvarservice.partitionLimit){
          this.selectedHost[i]["isSelected"] = status
          this.assetsData[0].partitions[this.selectedHost[i]["index"]]["isSelected"] = status
        // }
      }
    }
    else if (mode == 'search') {
      let selectallState = false
      for (let i = 0; i < this.selectedHost.length; i++) {
        if (!this.selectedHost[i]["isSelected"]) {
          selectallState = true
          break
        }
      }
      if (this.selectedHost.length == 0) {
        selectallState = true
      }
      // console.log("toggleActionSourceSelectall===========",status,searchval,mode,selectallState)
      if (selectallState) {
        this.sourceSelectAll.setValue(false, { emitEvent: false })
      }
      else {
        this.sourceSelectAll.setValue(true, { emitEvent: false })
      }
    }

    let selectedCount:number = 0 
    for (let i = 0; i < this.selectedHost.length; i++) {
      if (!this.selectedHost[i]["isSelected"]) {
        break
      }else{
        selectedCount+=1
      }
    }
    if(selectedCount === this.logvarservice.partitionLimit){
      this.partitionLimitReached = true
    }else{
      this.partitionLimitReached = false
    }

  }

  toggleselectRelativeTime(relative_obj: any) {
    this.selectedTimeRange = relative_obj.disp
    this.selectedTimeStructure = relative_obj

  }
  opentimeOverlay(origin: any, component, componentInputs, dimensions) {
    this.internalOverlayRef = this.dropdown.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    }, origin, component);
    return this.internalOverlayRef;
  }
  openRealtiveTimePanelClick(origin) {
    this.opentimeOverlay(origin, TimePanelComponent, [this.selectedTimeStructure, document.getElementById('time'), 1], ["auto", "auto"]);
  }
  openCustomTimePanelClick(origin) {
    this.opentimeOverlay(origin, TimePanelComponent, [this.selectedTimeStructure, document.getElementById('CustomTime'), 2], ["auto", "auto"]);
  }

  filterList(str,mode?,level?){
    // console.log(str)
    

    this.levelList.forEach((list,index)=>{

      if(mode === 'click'){
        if(list != level){

        let filtered=[]
        filtered = this.defaultStructure[list].filter((rule: any) => {
        if((rule.trim()).toLowerCase().includes((str.trim()).toLowerCase())){
          return rule
        }
      })
      this.structure[list]=filtered
      if(index == 0){
        this.structure[list]=filtered        
      }
      else {
        this.structure[list]=filtered
//console.log(filtered)
      
//         filtered.forEach(list=>{
//           if(this.sampleData.nodes[list].childrenIds.length){
// //console.log(this.sampleData.nodes[list].childrenIds)
//             this.sampleData.nodes[list].childrenIds.forEach(child=>{
//               if(!this.structure[this.sampleData.nodes[child].level].includes(this.sampleData.nodes[child].id)){
//                 this.structure[this.sampleData.nodes[child].level].push(this.sampleData.nodes[child].id)
//               }
//             })
//           }
//           // console.log(list)
//           let strList = list.split('/')
//           // console.log(strList)
//           if(strList.length <=2 ){
//             // console.log(this.sampleData.nodes[strList[0]])
//             if(!this.structure[this.sampleData.nodes[strList[0]].level].includes(this.sampleData.nodes[strList[0]].id)){
//               this.structure[this.sampleData.nodes[strList[0]].level].push(this.sampleData.nodes[strList[0]].id)
//             }
//           }else{

//             let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))

//            pathList.forEach(val=>{
//             if(!this.structure[this.sampleData.nodes[val].level].includes(this.sampleData.nodes[val].id)){
//               this.structure[this.sampleData.nodes[val].level].push(this.sampleData.nodes[val].id)
//             }
//            })
           
//           }
          
//         })


        // console.log(this.structure)
      }

        }
      }else{

        let filtered=[]
      filtered = this.defaultStructure[list].filter((rule: any) => {
        if((rule.trim()).toLowerCase().includes((str.trim()).toLowerCase())){
          return rule
        }
      })
      this.structure[list]=filtered
      if(index == 0){
        this.structure[list]=filtered        
      }
      else {
        this.structure[list]=filtered
       


        filtered.forEach(list=>{
          if(this.sampleData.nodes[list].childrenIds.length){
            // console.log(this.sampleData.nodes[list].childrenIds)
            this.sampleData.nodes[list].childrenIds.forEach(child=>{
              if(!this.structure[this.sampleData.nodes[child].level].includes(this.sampleData.nodes[child].id)){
                this.structure[this.sampleData.nodes[child].level].push(this.sampleData.nodes[child].id)
              }
            })
          }
          // console.log(list)
          let strList = list.split('/')
          // console.log(strList)
          if(strList.length <=2 ){
            // console.log(this.sampleData.nodes[strList[0]])
            if(!this.structure[this.sampleData.nodes[strList[0]].level].includes(this.sampleData.nodes[strList[0]].id)){
              this.structure[this.sampleData.nodes[strList[0]].level].push(this.sampleData.nodes[strList[0]].id)
            }
          }else{

            let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))
          
           pathList.forEach(val=>{
            if(!this.structure[this.sampleData.nodes[val].level].includes(this.sampleData.nodes[val].id)){
              this.structure[this.sampleData.nodes[val].level].push(this.sampleData.nodes[val].id)
            }
           })
           
          }
          
        })


        // console.log(this.structure)
      }

      }

      
    })

    

   
  }

  getLevelList(){
    let list=[]
    Object.keys(this.sampleData.nodes).forEach(key=>{
      list.push(this.sampleData.nodes[key].level)
    })
    let listSet=new Set(list)

    Array.from(listSet).forEach(data=>{
      this.selectedPath[data]=""
    })

    return Array.from(listSet)
  }


  getRoot(){
    let list=[]
    let name=[]
    let level
    this.sampleData.roots.forEach(key=>{
      Object.keys(this.sampleData.nodes).forEach(data=>{
        if(this.sampleData.nodes[data].id === key){
          this.rootList.push(this.sampleData.nodes[data])
          name.push(data)
          level=this.sampleData.nodes[data].level
          list.push(this.sampleData.nodes[data])
        }
      })
    })
    this.structure[level]=name
    // console.log(this.structure)
    return list
  }

  getChildren(id){
    let childObj={}
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        if(this.sampleData.nodes[key].childrenIds.length){
          this.sampleData.nodes[key].childrenIds.forEach(childKey=>{
            childObj[childKey] = (this.sampleData.nodes[childKey])
          })
        }
      }
    })
    // console.log(childObj)
    return childObj
  }

  getLevel(id){
    let level
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        level = this.sampleData.nodes[key].level
      }
    })
    return level
  }

  getLabel(id){
    let label
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        label = this.sampleData.nodes[key].label
      }
    })
    return label
  }

  getNewLabel(id){
      let label
      Object.keys(this.newSample.nodes).forEach(key=>{
        if(this.newSample.nodes[key].id === id){
          label = this.newSample.nodes[key].label
        }
      })
      return label
    }
  

  getParentId(id){
    let parent
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        parent = this.sampleData.nodes[key].parentId
      }
    })
    return parent
  }

  removeChip(chip ,i){
    // console.log({chip})
    // console.log({i})
    let index = this.selected.findIndex(val=> val.partition_name === chip)
    this.selected.splice(index,1)
    this.selectedAlias.removeAt(i,{emitEvent:false})
    // console.log("Array -> ",this.selected)
    // console.log("Control -> ",this.selectedAlias)
  }

  searchNodes(str){

    // let finalFilter=[]

  //   this.levelList.forEach(list=>{
  //     let filtered=[]
  //     filtered = this.newStructure[list].filter((rule: any) => {
  //     if((this.getNewLabel(rule).trim()).toLowerCase().includes((str.trim()).toLowerCase())){
  //       return rule
  //     }
  //   })
  //   filtered.forEach(val=>{finalFilter.push(val)})
  //   // this.newStructure[list]=filtered
  // })
  // Object.keys(this.newStructure).forEach(key=>{
  //   this.newStructure[key]=[]
  // })
  // finalFilter.forEach(root=>{
  //   let array=this.getFullChain(this.newSample.nodes,root)
  //   array.forEach(list=>{
  //     if(!this.newStructure[list.level].includes(list.id)){
  //       this.newStructure[list.level].push(list.id)
  //     }
  //   })
  // })

  
  let filtered= JSON.parse(JSON.stringify(this.mydata))
//console.log({filtered})


  // this.keepTrack.forEach(val=>{
  //   filtered=this.queryTable(filtered,{[this.getKey(val)]:val})
  // })

  // filtered=this.queryTable(JSON.parse(JSON.stringify(this.mydata)),this.keepTrackJr)

  // if(Object.values(this.keepTrackJr).length){
  //   filtered=this.queryTable(JSON.parse(JSON.stringify(this.mydata)),this.keepTrackJr)
  // }
  // else{
  //   filtered=JSON.parse(JSON.stringify(this.mydata))
  // }

  
  let empty =true
  Object.values(this.keepTrackJr).forEach(val=>{
    if(val.length > 0){
      empty = false
    }
  })
  if(!empty){
    // console.log("if")

    let queryObj={}

    Object.keys(this.keepTrackJr).forEach(key=>{
      if(this.keepTrackJr[key] != ""){
        queryObj[key] = this.keepTrackJr[key] 
      }
    })
    filtered=JSON.parse(JSON.stringify(this.queryTable(JSON.parse(JSON.stringify(this.mydata)),queryObj)))
  }
  else{
    // console.log("else")
    filtered=JSON.parse(JSON.stringify(this.mydata))
  }

  if(str.length){
    let filter = new Set
    //   filtered = this.newStructure[list].filter((rule: any) => {
    //       if((this.getNewLabel(rule).trim()).toLowerCase().includes((str.trim()).toLowerCase())){
    //         return rule
    //       }
    //   })

      filtered.forEach(val=>{
        Object.keys(val).forEach(key=>{
          if(val[key]?.toString().trim().toLowerCase().includes(str.toString().trim().toLowerCase())){
            // console.log("Filtered -->",val[key])
            // filtered.push(val)
            filter.add(val)
          }
        })
        
      })

     

      this.clickedNode = Array.from(filter)
//console.log("Filtered --->",this.clickedNode)
  }else{
    this.clickedNode=filtered
  }

  

  }

  getKey(node){
    let keyReturn
    this.mydata.forEach(val=>{
      Object.keys(val).forEach(key=>{
        if(val[key]=== node){
          keyReturn =key
          return key
        }
      })
    })
    return keyReturn
  }
  checkSelected(val){
    let check =false
    // if(this.keepTrack.includes(val)){
    //   check=true
    // }
    if(Object.values(this.keepTrackJr).includes(val)){
      check=true
    }
    return check
  }


  newRootClick(root,rootValue,mode){

// console.log("Root =---->",root)

// console.log("KeepTrack ->", this.keepTrack)


    // if(this.keepTrack.includes(root)){
    //   let index = this.keepTrack.findIndex(val => val === root)

    //   this.keepTrack.splice(index,1)
    //   this.clickedNode=JSON.parse(JSON.stringify(this.mydata))
    // }else{
    //   this.keepTrack.push(root)
    // }

    if(this.keepTrackJr[root] == rootValue){
      this.keepTrackJr[root] =""
      // this.clickedNode=JSON.parse(JSON.stringify(this.mydata))
    }else{
      this.keepTrackJr[root]= rootValue
    }

// console.log("KeepTrackJr ->", this.keepTrackJr)

    


// console.log( this.queryTable(this.mydata, { vendor_product:"Paloalto",sub_type: "allow" }))

    // this.keepTrack.forEach(val=>{
    //   // console.log(val)
    //   this.clickedNode=this.queryTable(this.clickedNode,{[this.getKey(val)]:val})
    // })

// console.log("KeepTrackJrValues",Object.values(this.keepTrackJr))

    let empty =true
    Object.values(this.keepTrackJr).forEach(val=>{
      if(val.length > 0){
        empty = false
      }
    })
    if(!empty){
      // console.log("if")

      let queryObj={}

      Object.keys(this.keepTrackJr).forEach(key=>{
        if(this.keepTrackJr[key] != ""){
          queryObj[key] = this.keepTrackJr[key] 
        }
      })
      this.clickedNode=JSON.parse(JSON.stringify(this.queryTable(JSON.parse(JSON.stringify(this.mydata)),queryObj)))
    }
    else{
      // console.log("else")
      this.clickedNode=JSON.parse(JSON.stringify(this.mydata))
    }

    


// console.log("=---->",this.clickedNode)
    

    // console.log(this.clickedNode)

    // console.log({[this.getKey(root)]:root})
    // console.log(this.getcolumn('vendor_product'))

    

    // if(this.selectedPath[this.newSample.nodes[root].level] === root){
    //   this.selectedPath[this.newSample.nodes[root].level] =''
    //   this.readyToAdd=false
    // }else{
    //   this.selectedPath[this.newSample.nodes[root].level]=root
    // }

//     let empty=true
//     Object.keys(this.selectedPath).forEach(key=>{
//       if(this.selectedPath[key]){
//         empty=false
//       }
//     })

//     if(empty){
//       this.newStructure=JSON.parse(JSON.stringify(this.newDefaultStructure))
//       this.selectedNode=''
//       this.readyToAdd=false
//     }else{

//       let array=this.getFullChain(this.newSample.nodes,root)

//       this.getPathToRoot(this.newSample.nodes,root)

//       let check=[]
//       let first =true
//       Object.keys(this.selectedPath).forEach((val,i)=>{
     
//         if(this.selectedPath[val]){
//           if(first){
//             array=this.getFullChain(this.newSample.nodes,this.selectedPath[val])
//             first =false
//           }
// //console.log(this.selectedPath[val])
// //console.log(root)
//           let obj={}
//           array.forEach(data=>{obj[data.id]=data})
// //console.log({obj})
//           array=this.getFullChain(obj,this.selectedPath[val])
//           // console.log({array})
//         }
//       })

//       // console.log(check)
      
//      let newSet = check.filter((item, index, arr) =>
//      arr.findIndex(obj => obj.id === item.id) !== index);
//     //  console.log(newSet)

//     // array=newSet

//       // console.log(array)

//       Object.keys(this.newStructure).forEach(key=>{
//         // if(this.newSample.nodes[root].level != key){
//           this.newStructure[key]=[]
//         // }
//       })
  
      
//       array.forEach(list=>{

//       //  if(this.selectedPath[list.level] === list.id){
//         this.newStructure[list.level].push(list.id)
//       //  }
//         // console.log(list)
//         // if(this.newSample.nodes[root].level != list.level){
         
//         // }
//       })
  
//       this.selectedNode=root

//       let hasDuplicate=false

//       Object.keys(this.newStructure).forEach(key=>{
//         // console.log(this.newStructure[key])
//         if(this.newStructure[key].length > 1){
//           hasDuplicate=true
//         }
//         // console.log({hasDuplicate})
//       })

//       if(hasDuplicate){
//         this.readyToAdd=false
//       }else{
//         this.readyToAdd=true
//       }

     
    
//         // if(!this.hasDuplicates(this.newStructure)){
//         //   this.readyToAdd=true
//         // }else{
//         //   this.readyToAdd=false
//         // }
     

//     }

    
   
  }



  hasDuplicates(arr) {
    return new Set(arr).size !== arr.length;
  }

  getAncestors(
    nodes: any,
    startId: string
  ): Node[] {

    const result: Node[] = [];
    const visited = new Set<string>();
    const stack = [...(nodes[startId]?.parentIds || [])];

    while (stack.length) {

      const id = stack.pop()!;
      if (visited.has(id)) continue;

      visited.add(id);

      const node = nodes[id];
      if (!node) continue;

      result.push(node);

      stack.push(...node.parentIds);
    }

    return result;
  }
  getDescendants(
    nodes: any,
    startId: string
  ): Node[] {

    const result: Node[] = [];
    const visited = new Set<string>();
    const stack = [...(nodes[startId]?.childrenIds || [])];

    while (stack.length) {

      const id = stack.pop()!;
      if (visited.has(id)) continue;

      visited.add(id);

      const node = nodes[id];
      if (!node) continue;

      result.push(node);

      stack.push(...node.childrenIds);
    }

    return result;
  }
  getFullChain(
    nodes: any,
    id: string
  ) {

    // console.log({nodes})

    let array=[]

    array=this.getAncestors(nodes, id)
    array.push(nodes[id])
    this.getDescendants(nodes, id).forEach(val=>{array.push(val)})

    return array
  }

  resetSelectedChips(){
    
  }
  
  resetEverything(){
    this.clickedNode =JSON.parse(JSON.stringify(this.mydata))
    // console.log(this.keepTrackJr)
    // console.log(this.keepTrackDefault)
    // this.keepTrack=[]
    this.keepTrackJr == JSON.parse(JSON.stringify(this.keepTrackDefault))

    Object.keys(this.keepTrackJr).forEach(key=>{
      this.keepTrackJr[key]=''
    })

    // console.log(this.keepTrackJr)
    this.assetSearch.setValue('',{emitEvent:false})
  }

  addChipClick(){

    if(this.selected.some(item => item.partition_name === this.clickedNode[0].partition_name)){
      this.toasterServie.ShowToaster("Already selected","neutral")
    }else{
      this.selected.push(this.clickedNode[0])
      this.addControl(this.clickedNode[0].partition_name_disp)
      this.resetEverything()
    }
      
  }

  addClick(){
    let string=''
    Object.keys(this.newStructure).forEach((key,i)=>{
      
      if(this.newStructure[key][0]){
        if(i !=0){
          string+='.'
        }
        string+=this.newStructure[key][0]
      }
    })
    // console.log("String-->",string)
    // console.log("Selected-->",this.selected)
    if(!this.selected.includes(string)){
      this.selected.push(string)
      this.addControl(string)
      this.resetSelection()
    }
   
  }

  rootClick(root,mode){
    let level
    let list=[]
    let temp={}
    if(this.selectedNode === root){
      this.selectedNode=''
      this.structure=JSON.parse(JSON.stringify(this.defaultStructure))
    }else{
      this.selectedNode=root
      if(this.sampleData.nodes[root].childrenIds.length){
        this.filterList(root,'click',this.getLevel(root))
      }else{
        // console.log(root)
        let string=JSON.parse(JSON.stringify(this.pathToLabel(root).replace(/\//g, ".")))
        let value=JSON.parse(JSON.stringify(root.replace(/\//g, ".")))
        if(this.selected.length < this.chipsLimit && !this.selected.includes(string)){
         
          this.selected.push(string)
          this.addControl(value)
        }
        this.selectedNode=''
        this.structure=JSON.parse(JSON.stringify(this.defaultStructure))
      }
    }

    // console.log(this.selectedAlias.getRawValue())

    

  }

  get selectedAlias() {
    return this.form.get('selectedAlias') as UntypedFormArray;
  }

  getDispValue(str){
    let string=''
    this.selected.forEach(val=>{
      // console.log({val})
      if(val.toLowerCase() === str){
        // console.log(val)
        string= val
      }
    })
    return string
  }


  getNewDispValue(str){
//console.log({str})
    let string=''
    let strList = str.split('.')


    strList.forEach((val,i)=>{

      if(i !=0){
        string+='.'
      }
      string+=this.getNewLabel(val)

    })
    return string
  }

  addControl(string){
    let index=this.selectedAlias.length
    let group = new FormGroup({
      [string]:new FormControl('S'+(index+1),[Validators.required,this.identifierValidation()])
    })
    this.selectedAlias.push(group ,{emitEvent:false})
    
  }

  pathToLabel(string){
    
    let strList = string.split('/')
    let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))
    let finalStr=''
    pathList.forEach((str,i) =>{
      if(i!= pathList.length-1){
        finalStr+=this.getLabel(str)+"/"
      }else{
        finalStr+=this.getLabel(str)
      }
    })
    // console.log(finalStr)
    // console.log(pathList)
    return finalStr
  }

  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  newDefault(){
    this.levelList.forEach(level=>{
      let list=[]
      Object.keys(this.newSample.nodes).forEach(key=>{

        if(level === this.newSample.nodes[key].level){
          list.push(key)
        }
      })
      this.newDefaultStructure[level]=list
    })

    this.newStructure=JSON.parse(JSON.stringify(this.newDefaultStructure))

//console.log(this.newStructure)
  }

  getDefault(){
    this.levelList.forEach(level=>{
      let list=[]
      Object.keys(this.sampleData.nodes).forEach(key=>{
        if(level === this.sampleData.nodes[key].level){
          let exists=false
          list.forEach(val=>{
            if(this.getLabel(val) === this.getLabel(key)){
              exists=true
            }
          })
          if(!exists){
            list.push(key)
          }
        }
      })
      this.defaultStructure[level]=list
    })
    this.structure = JSON.parse(JSON.stringify(this.defaultStructure))
//console.log('Structure -->',this.structure)
  }

  objectSize(obj: any): number {
    return Object.keys(obj || {}).length;
  }

  submitClick(){
    

    
    if(this.selectedAlias.value.length){
      // console.log("has length")
      if(this.selectedAlias.valid){
        // console.log("Valid")
        this.submitValid=true
      }else{
        this.submitValid=false
      }
    }else{
      this.submitValid=false
    }

    if(this.submitValid){

      let postObj=[]

      // console.log(this.selectedAlias.getRawValue())
      
      this.selectedAlias.getRawValue().forEach(key=>{
        let obj={}
        let arr=[]
//console.log(key)
        let name=Object.keys(key).toString().replace(/\./g, "/")
        // console.log({name})

        obj['alias']=key[Object.keys(key).toString()]

        let strList = name.split('/')
        let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))
        // console.log({strList})
        // console.log({pathList})

        // pathList.forEach(val=>{
        //   arr.push(this.newSample.nodes[val])
        // })

        // strList.forEach(val=>{
        //   arr.push(this.newSample.nodes[val])
        // })

        // arr.push(this.sampleData.nodes[name])

        // obj['nodes']=arr

        // postObj.push(obj)


      })

      postObj=this.selected

      this.overLayRef._cube.next(postObj)

//console.log(postObj)
      this.formCancel()
    }
  }


  getControlNames(group: AbstractControl): string[] {
    // console.log(Object.keys((group as FormGroup).controls))
    return Object.keys((group as FormGroup).controls);
  }

  resetSelection(){
    this.selectedNode=''
    this.structure=JSON.parse(JSON.stringify(this.defaultStructure))
    this.newStructure=JSON.parse(JSON.stringify(this.newDefaultStructure))

    Object.keys(this.selectedPath).forEach(val=>{
      this.selectedPath[val]=""
    })

    this.readyToAdd=false
    // console.log(this.selectedPath)
  }

  preProcess(){
//     this.data.forEach(val=>{
//       let string=''
//       val.nodes.forEach((key,i)=>{
//         if(i!=0){
//           string+='.'
//         }
//         string+=key.id
//         // if(!key.childrenIds.length){
//         //   this.buildControl(key.id,val.alias)
//         // }
//       })
// //console.log(string)
//       this.buildControl(string,val.alias)
//     })

// console.log("Data->",this.data)

this.data.partitions.forEach(val=>{
  this.selected.push(val)
  this.buildControl(val.partition_name)
})
  }

  buildControl(string){
    // let root=JSON.parse(JSON.stringify(this.pathToLabel(string).replace(/\//g, ".")))
    // let value=JSON.parse(JSON.stringify(string.replace(/\//g, ".")))
    // this.selected.push(root)
    // this.addDataControl(value,alias)
    
    this.addDataControl(string)
  }

  addDataControl(string){
    let index=this.selectedAlias.length
    let group = new FormGroup({
      [string]:new FormControl([Validators.required,this.identifierValidation()])
    })
    this.selectedAlias.push(group ,{emitEvent:false})
  }

  identifierValidation(): ValidatorFn {
    return (control: AbstractControl) => {
  
      const regex = /^(?:[_A-Za-z][A-Za-z0-9_.]*|"(?:[^"]|\/")*")$/;
  
      if (!control.value) return null; // allow empty
  
      return regex.test(control.value)
        ? null
        : { identifierError: true };
    };
  }

  // getPathToRoot(
  //   nodes: Record<string, Node>,
  //   startId: string
  // ): Node[] {
  
  //   const path: Node[] = [];
  //   const visited = new Set<string>();
  
  //   const dfs = (currentId: string): boolean => {
  //     if (visited.has(currentId)) return false;
  //     visited.add(currentId);
  //     let node:any
  
  //     node = nodes[currentId];
  //     if (!node) return false;
  
  //     path.unshift(node);
  
  //     // If root
  //     if (!node.parentIds || node.parentIds.length === 0) {
  //       return true;
  //     }
  
  //     for (const parentId of node.parentIds.filter(Boolean)) {
  //       if (dfs(parentId)) {
  //         return true; // stop at first valid path
  //       }
  //     }
  
  //     path.shift(); // backtrack
  //     return false;
  //   };
  
  //   dfs(startId);
  //   console.log({path})
  //   return path;
  // }
  getPathToRoot(
    nodes: Record<string, Node>,
    startId: string
  ): Node[][] {
  
    const paths: Node[][] = [];
  
    const dfs = (currentId: string, path: Node[]) => {
      let node:any
      node = nodes[currentId];
      if (!node) return;
  
      const newPath = [node, ...path];
  
      // If no parents → reached root
      if (!node.parentIds || node.parentIds.length === 0) {
        paths.push(newPath);
        return;
      }
  
      for (const parentId of node.parentIds.filter(Boolean)) {
        dfs(parentId, newPath);
      }
    };
  
    dfs(startId, []);
//console.log({paths})
    return paths;
  }

  queryTable(rows: any, query: any ): any {
// console.log({rows})
    return rows.filter(row => {

      for (const key in query) {

        const value = query[key];

        if (value === undefined) continue;

        // console.log("Row =---->",row[key])

        
          if (key in row  && !row[key]?.includes(value)) return false;
        
      }

      return true;
    });
  }
  getcolumn(level){
    let result = new Set()
    let filtered = this.queryTable(this.mydata, {  })
    // if(!this.clickedNode.length){
    //   // console.log("if")

    //   this.clickedNode = filtered
    // }else{
    //   // console.log("else",this.clickedNode.length)
    // }
    // console.log({filtered})
    // console.log(this.clickedNode)
    this.clickedNode.forEach(element => {
      // console.log({element})
      result.add(element[level])      
    });
    // console.log("Array from result",Array.from(result).sort())
  return result ? Array.from(result).sort():[];
  }

  
  ngOnDestroy(): void {
    this.submitValid=true
    this.$destroy.next(true)
    this.$destroy.unsubscribe()
  }
}
